import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIconBrand } from '@mylighthouse/prism-ember';
import type { IconBrandName } from '@mylighthouse/prism-ember/types/components/prism/icon-brand';

const TEXT_SIZE_CLASS_MAP = {
  small: 'text-200--regular',
  medium: 'text-300--regular',
} as const;

interface ParityOtaWithIconSignature {
  Args: {
    otaId: string;
    size: keyof typeof TEXT_SIZE_CLASS_MAP;
  };
}

export default class ParityOtaWithIcon extends Component<ParityOtaWithIconSignature> {
  @service declare ota: Services['ota'];

  get hasIcon(): boolean {
    return this.ota.hasIcon(this.args.otaId);
  }

  get icon(): IconBrandName {
    return this.args.otaId as IconBrandName;
  }

  get otaPrettyName(): string {
    return this.ota.otaIdToPrettyName(this.args.otaId);
  }

  get textClass(): string {
    const sizeClass =
      TEXT_SIZE_CLASS_MAP[this.args.size] || TEXT_SIZE_CLASS_MAP.medium;

    return `${sizeClass} truncate`;
  }

  <template>
    {{#if this.hasIcon}}
      <div class="flex items-center justify-start gap-100">
        <PrismIconBrand @name={{this.icon}} />
        <p class={{this.textClass}}>{{this.otaPrettyName}}</p>
      </div>
    {{else}}
      <p class={{this.textClass}}>{{this.otaPrettyName}}</p>
    {{/if}}
  </template>
}
